import { createSlice } from "@reduxjs/toolkit";

// Get the initial language value from localStorage or set it to "en" if not present
const initialLanguage = localStorage.getItem("lang") || "en";

export const languageSlice = createSlice({
  name: "language",
  initialState: {
    value: initialLanguage, // Set initial language from localStorage or "en"
  },
  reducers: {
    setLanguage: (state, action) => {
      state.value = action.payload;
      localStorage.setItem("lang", action.payload); // Update localStorage when language changes
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export const selectLanguage = (state) => state.language.value;

export default languageSlice.reducer;
